import { LogoutPage } from "@shared/features/auth/pages/LogoutPage";
import {
  PLATFORM_RESET,
  usePlatformDispatch,
} from "@platform//PlatformContext";

export function PlatformLogoutPage() {
  const dispatch = usePlatformDispatch();

  const onSuccess = () => {
    dispatch({ type: PLATFORM_RESET });
  };

  return <LogoutPage onSuccess={onSuccess} redirectTo="/" />;
}

export default PlatformLogoutPage;
